import { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import * as D from "assets/iconsSVG/rowTopDownIcon";
import * as MaterialUI from "@material-ui/core";
import { useResultadoAnalise } from "services/api/AppWeb_Oportunidade/put-resultado-analise";
import SelectComponent from "components/SelectG";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { useResultadosAnalise } from "services/api/AppWeb_Oportunidade/get-resultados-analise";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
}

export const ModalResultadoAnalise = (data: Data) => {
  const { usuarioComercial } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const [justificativa, setJustificativa] = useState<any>("");
  const [resultado, setResultado] = useState({ label: "", value: 0 });
  const [tentouSalvar, setTentouSalvar] = useState(false);
  const { data: dataResultados, isFetching } = useResultadosAnalise();
  const dataResultadosMap =
    dataResultados?.map((item: any) => ({
      label: item?.nome,
      value: item?.id,
    })) || [];

  const resultadoValido = resultado.value !== 0;
  const justificativaValida = justificativa.trim().length > 0;
  const formValido = resultadoValido && justificativaValida;

  const {
    mutate: mutateResultadoAnalise,
    isLoading: isLoadingResultadoAnalise,
  } = useResultadoAnalise();

  const handleSubmit = () => {
    if (!formValido) {
      setTentouSalvar(true);
      return;
    }

    mutateResultadoAnalise(
      {
        idOportunidade: data.dataDetalheOportunidade.idOportunidade,
        codigoResultado: resultado.value,
        usuarioComercial,
        justificativa,
      },
      {
        onSuccess: () => {
          data.refetchDetalheOportunidade();
          data.refetchHistorico();
          data.onClose();
        },
      }
    );
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <D.RowTopDownIcon />
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
        <S.SpaceY space={16} />
        <S.TextTitle>Resultado da análise</S.TextTitle>
      </S.Header>
      <S.SpaceY space={16} />
      <S.Body>
        <SelectComponent
          label="Resultado"
          data={dataResultadosMap}
          disabled={isFetching}
          onChange={(event) => {
            const selectedValue = event.target.value;
            const selectedItem = dataResultadosMap.find(
              (item: any) => item.value === selectedValue
            );
            setResultado(selectedItem || { label: "", value: 0 });
          }}
          value={resultado.value as any}
          placeholder="Selecione"
          borderRadius="8px"
          error={tentouSalvar && !resultadoValido}
        />
        {tentouSalvar && !resultadoValido && (
          <S.ErrorText>Selecione um resultado.</S.ErrorText>
        )}
        <S.SpaceY space={16} />
        <S.MultLineField>
          <S.LabelText>Justificativa (obrigatório)</S.LabelText>
          <S.TextField
            onChange={(e: any) => setJustificativa(e.target.value)}
            label="Multiline"
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            value={justificativa}
            inputProps={{ maxLength: 4000 }}
            error={tentouSalvar && !justificativaValida}
          />
          <S.CountText>{justificativa.length}/4000</S.CountText>
          {tentouSalvar && !justificativaValida && (
            <S.ErrorText>Campo obrigatório.</S.ErrorText>
          )}
        </S.MultLineField>
        <S.SpaceY space={32} />
        <S.Row style={{ gap: 16 }}>
          <S.Button
            onClick={() => {
              data.onClose();
            }}
            color="#ffffff"
            border="1px solid #A3A3A6"
          >
            <S.TextButton color="#424248">Cancelar</S.TextButton>
          </S.Button>
          <S.Button
            onClick={() => {
              handleSubmit();
            }}
            disabled={isLoadingResultadoAnalise}
            style={{ opacity: formValido ? 1 : 0.5 }}
          >
            {isLoadingResultadoAnalise ? (
              <MaterialUI.CircularProgress
                size={22}
                style={{ color: "#ffffff" }}
              />
            ) : (
              <S.TextButton color="#FFFFFF">Salvar</S.TextButton>
            )}
          </S.Button>
        </S.Row>
      </S.Body>
    </S.Content>
  );
};
